import { mapGetters } from 'vuex';
import TimelineTaskList from '../widgets/TimelineTaskList';
export default {
  name: 'TasksTimeline',
  computed: {
    ...mapGetters('tasks', ['prePicture', 'postPicture', 'preRetake', 'postRetake'])
  },
  components: {
    TimelineTaskList
  }
};